import React from "react";
import "./App.css";
import Application from "./components/Application";

function App() {
  return (
    <Application />
  );
}

export default App;
